var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEyeExample(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 98,
    viewBox: "0 0 97 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EMOTICONE",
    transform: "translate(-1548 -390)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1420",
    "data-name": "Rectangle 1420",
    transform: "translate(1548 390)",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 98,
    rx: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 95,
    height: 96,
    rx: 20,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(1567.865 323.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15432",
    "data-name": "Path 15432",
    d: "M28.635,98.725c-10.942,0-20.865,5.986-28.187,15.71a2.267,2.267,0,0,0,0,2.706c7.322,9.735,17.245,15.722,28.187,15.722s20.865-5.986,28.187-15.71a2.267,2.267,0,0,0,0-2.706C49.5,104.711,39.577,98.725,28.635,98.725Zm.785,29.089a12.045,12.045,0,1,1,11.235-11.235A12.053,12.053,0,0,1,29.42,127.814Zm-.363-5.553a6.486,6.486,0,1,1,6.057-6.057A6.475,6.475,0,0,1,29.057,122.261Z",
    transform: "translate(0 -12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "SEE_AN_EXEMPLE",
    "data-name": "SEE AN EXEMPLE",
    transform: "translate(29.135 135.794)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Avenir-Black, Avenir",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.116,
    y: 0
  }, "SEE AN"), /*#__PURE__*/React.createElement("tspan", {
    x: -28.338,
    y: 14
  }, "EXEMPLE"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeExample);
export default __webpack_public_path__ + "static/media/icon-eye-example.d08b36b1656e301c8e45e700fc6f4378.svg";
export { ForwardRef as ReactComponent };